import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { ArticuloMovimiento, ArticuloMovimientoTipo } from "@/shared/types/articulo-movimiento";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface ArticuloMovimientosQuery extends BaseQuery {
    desde?: string,
    hasta?: string,
    tipo?: ArticuloMovimientoTipo
}

export async function getAllArticuloMovimientos(query?: ArticuloMovimientosQuery): Promise<QueryResponse<ArticuloMovimiento>> {
    await sleep(1000);
    const response = await api.get("articulo_movimientos", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllArticuloMovimientosQuery(query: ArticuloMovimientosQuery = {}, queryConfig: QueryConfig<QueryResponse<ArticuloMovimiento>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllArticuloMovimientos(query),
        queryKey: ["articulo_movimientos", query],
    })
}

export interface GetAllArticuloMovimientoQueryProps {
    query: ArticuloMovimientosQuery,
    queryConfig?: QueryConfig<QueryResponse<ArticuloMovimiento>>,
    children: (queryResult: QueryResult<QueryResponse<ArticuloMovimiento>>) => ReactNode
}

export function GetAllArticuloMovimientosQuery({
    query,
    queryConfig,
    children
}: GetAllArticuloMovimientoQueryProps) {
    const queryResult = useGetAllArticuloMovimientosQuery(query, queryConfig);
    return children && children(queryResult);
}